import { render, staticRenderFns } from "./ColorsAutocomplete.vue?vue&type=template&id=3176fbc4&"
import script from "./ColorsAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./ColorsAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports